import { getTemplate } from './utilities/helpers';

import styles from './_index.module.scss';

export interface ErrorProps {
  description?: React.ReactNode;
  header?: string;
  status?: string | number;
}

const Error = ({ description, header, status }: ErrorProps) => {
  const { descriptionText, headerText, imageSource } = getTemplate({ description, header, status });

  return (
    <div className={styles['error']}>
      <img alt={headerText} src={imageSource} />
      <h2>
        <strong>{headerText}</strong>
      </h2>
      <p>{descriptionText}</p>
    </div>
  );
};

export default Error;
